const Certifications = () => {
  return <h1>Certifications page</h1>
}

export default Certifications;